export default __webpack_public_path__ + "static/media/bot_full.f84e1d2c.png";